import styled from 'styled-components'

/**
 * Container for the SimpleRelatedSoles component.
 */
export const SimpleRelatedSolesContainer = styled.p`
  margin: 0;
  padding: 0;
  font-family: Jost;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 125%;
  letter-spacing: 0px;

  a {
    font-family: Jost;
    font-weight: 500;
    font-size: 1.4rem;
    line-height: 125%;
    letter-spacing: 0px;
    color: ${({ theme }) => theme.colors.primary};

    &:hover {
      text-decoration: underline;
    }
  }
`
